// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"clear-formatting"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M22.2739 11.5454L14.0312 3.30273L5.78861 11.5454L14.0312 19.788L22.2739 11.5454Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M5.78831 11.5454L1.66699 15.6667L7.16209 21.1618L18.9997 21.1618M5.78831 11.5454L14.031 3.30273L22.2736 11.5454L14.031 19.788L5.78831 11.5454ZM14.3561 19.4648L12.6696 21.1635L13.2251 20.6039","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ClearFormattingIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'clear-formatting',
    ref,
    icon: element,
  },
));

ClearFormattingIcon.displayName = 'ClearFormattingIcon';

export default ClearFormattingIcon;
